import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadosClienteRoutingModule } from './chamados-cliente-routing.module';
import { ChamadosListClienteComponent } from './components/chamados-list-cliente/chamados-list-cliente.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [ChamadosListClienteComponent],
  exports: [ChamadosListClienteComponent],
  imports: [
    CommonModule,
    ChamadosClienteRoutingModule,
    MDBBootstrapModule,
    SharedModule
  ],
})
export class ChamadosClienteModule { }
